/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios'
// import isEmpty from 'lodash/isEmpty'

import createErrorMessage from './createErrorMessage'
import isServiceError from './isServiceError'

const defaultOptions = {
  useMock: false,
  delay: 0,
  jsonMock: '',
  method: 'get',
  url: '',
  params: {},
  data: {},
  timeout: 600000,
  headers: {}
}

export default (userOptions) => {
  const options = { ...defaultOptions, ...userOptions }
  const { useMock, jsonMock, url, delay } = options
  const serviceURL = useMock ? `/JSONMockup/${jsonMock}` : url

  return new Promise((resolve) => {
    setTimeout(async () => {
      if (useMock) {
        options.method = 'get'
        options.url = serviceURL
      }
      resolve(fetch(options))
    }, delay * 1000)
  })
}


const getResponseData = (res, options) => {
  if (options.useMock && options.hybridModule) {
    const status = res.data.head.code
    return { status, data: res.data }
  }

  return res
}

const fetch = async (options) => {
  try {
    options.method.toLowerCase() === 'get' && (delete options['data']);

    const res = await axios(options)
    const responseData = getResponseData(res, options)

    if (isServiceError(responseData, options)) {
      createErrorMessage(responseData, options)
    }
    
    return {
      status: responseData?.status,
      statusText: responseData?.statusText,
      data: responseData?.data,
      error: responseData?.error
    }
  } catch (err) {
    createErrorMessage(err.response, options)
  }
}
